export default __webpack_public_path__ + "static/media/96_desktop.c310f74c.jpg";